import {
  defAlias,
  defBaseUnit,
  defInvertedUnit,
  defSimpleUnit,
} from '../registry';

defSimpleUnit('100km', 'meter', 100000);

// MPG formula derived using:
//
// 1 gallon = 3.785411784 liters -- see volume.ts
// 1 mile = 0.01609344 (100 kilometers) -- see length.ts
// 1 liter / (3.785411784 l/gal) = 0.2641720524 gal
// 100 km / (1.609344 km/mi) = 62.13711922 mi
//
// Cm = 0.01609344 100km/mile * 0.2641720524 gal/l = 0.00425144 100km-gal/mile-liter
//
// 1 / ( Cm * x[mpg]) = y[l/100km]
// (1/Cm) / x[mpg] = y[l/100km]
// F = 1/Cm
// F / x[mpg] = y[l/100km]
// F x[mpg] / x[mpg] = x[mpg] * y[l/100km]
// F = x[mpg] * y[l/100km]
//
// y[l/100km] = F / x[mpg]
// x[mpg] = F / y[l/100km]
//
// F = 1 / Cm = 235.2145833

export const fuelEconomyUnits = [
  defBaseUnit('l/100km', 'liter/100km'),
  defInvertedUnit('mpg', 'mile/gallon', 'l/100km', 235.21442147),
  defInvertedUnit('km/l', 'kilometer/liter', 'l/100km', 100),
];

defAlias('liter_per_100km', 'l/100km');
